import type { FC } from "preact/compat";
import { Outlet } from "react-router-dom";
import { Meta } from "~/organisms";

const Public: FC = () => (
    <div className="w-screen h-screen max-w-screen max-h-screen overflow-hidden flex flex-col -top-safe-top relative bg-sky-950 text-white">
        <Meta />
        <Outlet />
    </div>
);

export default Public;
